import {
  OnlinePlayer,
  OnlinePlayersResponse,
} from "../types/battle"
import { normalizeAvailableRanks } from "./radarStatus"
import { normalizeBattlePlayerInfo } from "./challengePayload"

function normalizeOnlinePlayer(raw: unknown): OnlinePlayer | null {
  const base = normalizeBattlePlayerInfo(raw)
  if (!base) return null
  const obj =
    raw && typeof raw === "object" && !Array.isArray(raw)
      ? (raw as Record<string, unknown>)
      : {}
  const availableRanks =
    normalizeAvailableRanks(obj.availableRanks ?? obj.available_ranks) ?? []

  return { ...base, availableRanks }
}

export function normalizeOnlinePlayersResponse(data: unknown): OnlinePlayersResponse {
  const obj =
    data && typeof data === "object" && !Array.isArray(data)
      ? (data as Record<string, unknown>)
      : {}
  const nested = obj.data ?? obj.result ?? obj.payload
  const source =
    nested && typeof nested === "object" && !Array.isArray(nested)
      ? (nested as Record<string, unknown>)
      : obj
  const rawList = Array.isArray(source.players) ? source.players : []
  const players = rawList
    .map(normalizeOnlinePlayer)
    .filter((player): player is OnlinePlayer => player != null)

  return { players }
}

/** Актуальная карточка игрока из списка (после дозагрузки стихии). */
export function resolveOnlinePlayer(
  selected: OnlinePlayer | null,
  players: OnlinePlayer[]
): OnlinePlayer | null {
  if (!selected) return null
  return players.find((player) => player.userId === selected.userId) ?? selected
}
